"use strict";
/**
 * CatalogItem Response Types
 *
 * Response DTOs for catalog item endpoints.
 */
Object.defineProperty(exports, "__esModule", { value: true });
